/*
  Lyana Header -- adds hover-intent opening to the desktop Collections mega
  menu without touching its existing behaviour. Escape-to-close, focus-out
  closing, aria-expanded/aria-controls and the click/Enter toggle are all
  already provided natively by the theme's own <details>/<summary> markup
  and assets/details-disclosure.js + the global Escape handler in
  assets/global.js -- this file only ever sets the native `open` property,
  so it can never drift out of sync with that existing state.

  Desktop only (matches the theme's own >=990px breakpoint for the mega
  menu); below that the drawer is used instead and this does nothing.
*/
(function () {
  if (window.__lyanaHeaderInit) return;
  window.__lyanaHeaderInit = true;

  var OPEN_DELAY = 150;
  var CLOSE_DELAY = 250;
  var desktopQuery = window.matchMedia('(min-width: 990px)');

  function init() {
    var menus = document.querySelectorAll('.header__inline-menu header-menu');
    var items = [];

    menus.forEach(function (menu) {
      var details = menu.querySelector(':scope > details.mega-menu');
      var summary = details && details.querySelector(':scope > summary');
      if (!details || !summary) return;
      items.push({ menu: menu, details: details, summary: summary, openTimer: null, closeTimer: null });
    });

    if (!items.length) return;

    function closeNow(item) {
      clearTimeout(item.openTimer);
      clearTimeout(item.closeTimer);
      if (item.details.open) {
        item.details.open = false;
        item.summary.setAttribute('aria-expanded', 'false');
      }
    }

    function openItem(item) {
      if (!desktopQuery.matches) return;
      clearTimeout(item.closeTimer);
      clearTimeout(item.openTimer);
      item.openTimer = setTimeout(function () {
        items.forEach(function (other) {
          if (other !== item) closeNow(other);
        });
        if (!item.details.open) {
          item.details.open = true;
          item.summary.setAttribute('aria-expanded', 'true');
        }
      }, OPEN_DELAY);
    }

    function scheduleClose(item) {
      if (!desktopQuery.matches) return;
      clearTimeout(item.openTimer);
      clearTimeout(item.closeTimer);
      item.closeTimer = setTimeout(function () {
        closeNow(item);
      }, CLOSE_DELAY);
    }

    items.forEach(function (item) {
      item.menu.addEventListener('mouseenter', function () {
        openItem(item);
      });
      item.menu.addEventListener('mouseleave', function () {
        scheduleClose(item);
      });
      item.summary.addEventListener('focus', function () {
        openItem(item);
      });
      // A native click/Enter toggle (browser's own <details> behaviour)
      // authoritatively changes state; drop any pending hover-intent timer
      // so it can't stomp on a state change the user just made explicitly.
      item.details.addEventListener('toggle', function () {
        clearTimeout(item.openTimer);
        clearTimeout(item.closeTimer);
      });
    });

    // Click outside the trigger+panel closes it -- native <details> only
    // closes on click of its own summary or via focus-out, not on a click
    // elsewhere on the page (e.g. a non-focusable area).
    document.addEventListener('click', function (event) {
      items.forEach(function (item) {
        if (!item.details.open) return;
        if (item.menu.contains(event.target)) return;
        closeNow(item);
      });
    });

    desktopQuery.addEventListener('change', function (event) {
      if (!event.matches) items.forEach(closeNow);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
